var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 652.64 860"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efeff5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_2",
    "data-name": "Vrstva 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-2",
    "data-name": "Vrstva 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-3",
    "data-name": "Vrstva 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "222.85 0 0 222.96 206.93 430 0 637.04 222.85 860 652.64 430 222.85 0"
  })))))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NTIuNjQgODYwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2VmZWZmNTt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IlZyc3R2YV8yIiBkYXRhLW5hbWU9IlZyc3R2YSAyIj48ZyBpZD0iVnJzdHZhXzEtMiIgZGF0YS1uYW1lPSJWcnN0dmEgMSI+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IlZyc3R2YV8xLTMiIGRhdGEtbmFtZT0iVnJzdHZhIDEiPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIyMjIuODUgMCAwIDIyMi45NiAyMDYuOTMgNDMwIDAgNjM3LjA0IDIyMi44NSA4NjAgNjUyLjY0IDQzMCAyMjIuODUgMCIvPjwvZz48L2c+PC9nPjwvZz48L3N2Zz4=";
export { SvgXLeft as ReactComponent };